import { lazy, Suspense } from 'react';
import { Box } from '@mui/material';

const FooterBlock = lazy(() => import('layout/CommonLayout/FooterBlock'));

/**
 * Route modifier that wraps CommonLayout with footer for landing pages
 * @param {React.Component} LayoutComponent - The layout component (e.g., CommonLayout)
 * @param {object} layoutProps - Props to pass to the layout component
 * @returns {React.Component} Wrapped component with footer
 */
export const withFooter = (LayoutComponent, layoutProps = {}) => {
  return (props) => {
    // Only add footer for landing layout
    if (layoutProps.layout === 'landing') {
      return (
        <>
          <LayoutComponent {...props} {...layoutProps} />
          <Suspense fallback={null}>
            <Box
              sx={{
                opacity: 0,
                animation: 'fadeIn 0.5s ease-in-out forwards',
                animationDelay: '0.5s',
                '@keyframes fadeIn': {
                  '0%': { opacity: 0 },
                  '100%': { opacity: 1 }
                }
              }}
            >
              <FooterBlock isFull={true} />
            </Box>
          </Suspense>
        </>
      );
    }

    // For non-landing layouts, return as-is
    return <LayoutComponent {...props} {...layoutProps} />;
  };
};
